
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 15.428A7.429 7.429 0 108 .571a7.429 7.429 0 000 14.857zM8 4v3.429","stroke":"#748190","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8 11.428a.571.571 0 100-1.142.571.571 0 000 1.143z","stroke":"#748190","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    